var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content pb-0" },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-user-circle",
            backPath: "/configurations/watchmen",
          },
        },
        [
          _vm.watchman && _vm.watchman.name
            ? _c("h1", [
                _vm._v("\n      " + _vm._s(_vm.watchman.name) + "\n    "),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.canReadWatchmen
        ? _c("div", { staticClass: "scroll" }, [
            _vm.isFormLoading ? _c("div", [_c("UiSpinner")], 1) : _vm._e(),
            _vm._v(" "),
            _vm.isFormError
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-danger mb-3",
                      attrs: { role: "alert" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.error_message")) +
                          "\n      "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isFormLoading && !_vm.isFormError
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c(
                        "UiCard",
                        [
                          _c(
                            "FormWrapper",
                            [
                              _c("WatchmanForm", {
                                model: {
                                  value: _vm.watchman,
                                  callback: function ($$v) {
                                    _vm.watchman = $$v
                                  },
                                  expression: "watchman",
                                },
                              }),
                              _vm._v(" "),
                              _vm.canUpdateWatchmen
                                ? _c(
                                    "div",
                                    { staticClass: "pb-4" },
                                    [
                                      _c(
                                        "Button2",
                                        {
                                          staticClass: "btn-brand",
                                          attrs: {
                                            disabled:
                                              !_vm.isFormModified ||
                                              _vm.isFormSubmited ||
                                              _vm.watchman.name === "",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handeSaveWatchmanDetails()
                                            },
                                          },
                                        },
                                        [
                                          _vm.isFormSubmited
                                            ? _c("span", {
                                                staticClass:
                                                  "spinner-border spinner-border-sm ml-2",
                                                attrs: {
                                                  role: "status",
                                                  "aria-label":
                                                    _vm.$t("global.loading"),
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.$t("global.save")) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.watchman.profiles.length
                                ? _c(
                                    "FormControl",
                                    [
                                      _c("FormLabel", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "watchmen.form.profiles_label"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("FormElement", [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "m-0 list-unstyled d-flex flex-column",
                                            staticStyle: { gap: "4px" },
                                          },
                                          _vm._l(
                                            _vm.watchman.profiles,
                                            function (profile) {
                                              return _c(
                                                "li",
                                                { key: profile.id },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "d-inline-flex align-items-center",
                                                      attrs: {
                                                        to:
                                                          "/configurations/profiles/" +
                                                          profile.id,
                                                      },
                                                    },
                                                    [
                                                      _c("ProfileIcon", {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          icon: profile.icon,
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(profile.name) +
                                                          "\n                    "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.watchman.procedures.length
                                ? _c(
                                    "FormControl",
                                    [
                                      _c("FormLabel", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "watchmen.form.monitoring_label"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("FormElement", [
                                        _c(
                                          "ul",
                                          { staticClass: "m-0 pl-4" },
                                          _vm._l(
                                            _vm.watchman.procedures,
                                            function (procedure) {
                                              return _c(
                                                "li",
                                                { key: procedure.id },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      staticClass:
                                                        "text-truncate",
                                                      attrs: {
                                                        to: {
                                                          name: "RemoteMonitoringShow",
                                                          params: {
                                                            id: procedure.id,
                                                          },
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            procedure.name
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.canDeleteWatchmen
                                ? _c(
                                    "FormControl",
                                    [
                                      _c("FormLabel", [
                                        _vm._v(
                                          _vm._s(_vm.$t("watchmen.form.delete"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "FormElement",
                                        [
                                          !!_vm.watchman.profiles.length ||
                                          !!_vm.watchman.procedures.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "alert alert-info mb-3",
                                                  attrs: { role: "alert" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "watchmen.form.errors.no_delete"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "Button2",
                                            {
                                              attrs: {
                                                disabled:
                                                  !!_vm.watchman.profiles
                                                    .length ||
                                                  !!_vm.watchman.procedures
                                                    .length,
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.handleDeleteWatchman()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "watchmen.form.delete"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-8" },
                    [
                      _c(
                        "UiCard",
                        [
                          _vm.canBrowseChannels
                            ? _c(
                                "FormControl",
                                [
                                  _c("FormLabel", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("watchmen.form.channels_label")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "FormElement",
                                    { staticStyle: { width: "100%" } },
                                    [
                                      !_vm.channels.length
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-info mb-3",
                                              attrs: { role: "alert" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "watchmen.form.errors.no_channels"
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.channels.length
                                        ? _c(
                                            "table",
                                            {
                                              staticClass: "table w-100",
                                              staticStyle: {
                                                "border-bottom":
                                                  "1px solid #dee2e6",
                                              },
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "watchmen.channels.type.label"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "watchmen.channels.value"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "watchmen.channels.validation"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "watchmen.channels.profiles"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "watchmen.channels.rm_procedures"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.channels,
                                                  function (channel) {
                                                    return _c("ChannelRow", {
                                                      key: channel.id,
                                                      attrs: {
                                                        channel: channel,
                                                      },
                                                      on: {
                                                        onEditChannel:
                                                          _vm.openModalEditChannel,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "Button2",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleOpenModalAddChannel($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("watchmen.channels.add")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "editChannelModal",
        attrs: { title: _vm.$t("watchmen.channels.editChannel") },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("ChannelEdit", {
                  attrs: { channelId: _vm.editChannelId },
                  on: {
                    onSave: _vm.updateChannelsAfterChannelEdit,
                    onDelete: _vm.updateChannelsAfterChannelDeleted,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("BasicModal", {
        ref: "addChannelModal",
        attrs: { title: _vm.$t("watchmen.channels.addChannel") },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("ChannelNew", {
                  attrs: { watchmanId: _vm.watchman.id },
                  on: { onSave: _vm.updateChannelsAfterChannelAdded },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }